import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import { FadeUp, MaskedReveal } from "@/components/Motion";
import { CheckCircle2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentSuccess() {
  const q = new URLSearchParams(useLocation().search);
  const session_id = q.get("session_id");
  const [status, setStatus] = useState("polling");

  useEffect(() => {
    if (!session_id) {
      setStatus("unknown");
      return;
    }
    let n = 0;
    const tick = async () => {
      try {
        const r = await axios.get(`${API}/payments/status/${session_id}`);
        if (r.data.payment_status === "paid") {
          setStatus("paid");
          return;
        }
      } catch {}
      n += 1;
      if (n < 10) setTimeout(tick, 2000);
      else setStatus("timeout");
    };
    tick();
  }, [session_id]);

  return (
    <div className="pt-20 min-h-[70vh]" data-testid="payment-success-page">
      <section className="editorial-container">
        <FadeUp>
          <div className="max-w-3xl">
            <div className="flex items-center gap-3 text-sage">
              <CheckCircle2 size={24} />
              <span className="overline">Payment received</span>
            </div>
            <h1 className="mt-8 font-serif text-6xl md:text-7xl leading-[1] tracking-tight text-ink">
              <MaskedReveal text="Welcome to" as="span" className="block" animate />
              <MaskedReveal text="the Mail Club." as="span" className="block italic text-terracotta" delay={0.2} animate />
            </h1>
            <p className="mt-8 font-serif text-2xl italic text-ink/80 leading-relaxed">
              Thank you. Your first envelope will begin its journey to you within the next
              10–14 days.
            </p>
            <p className="mt-4 font-serif text-lg text-ink/60">
              Status: <span className="italic">{status}</span>
              {session_id ? ` · Ref: ${session_id.slice(0, 12)}…` : ""}
            </p>
            <div className="mt-10 flex gap-4">
              <Link to="/" className="btn-pill">Return home</Link>
              <Link to="/reading-room" className="btn-pill ghost">The Reading Room</Link>
            </div>
          </div>
        </FadeUp>
      </section>
    </div>
  );
}
